import { FAQItem } from "../../components/FAQItem";
import { faqData } from "../../constants/faqConstant";

export const FAQSection = () => {
    const data = faqData.filter(item => item.isPirority);
    return (
        <div className="bg-white dark:bg-zinc-800">
            <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
                <div className="mx-auto max-w-4xl">
                    <h2 className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
                        Frequently asked questions
                    </h2>
                    <div className="mt-10">
                        <FAQItem data={data} />
                    </div>
                </div>
                {/* <div className="mt-8 p-6 bg-white dark:bg-zinc-800 text-center">
                    <p className="text-lg font-medium text-gray-900 dark:text-white">Still have questions?</p>
                    <a href="/faq" className="mt-2 inline-block text-indigo-600 hover:underline">Browse all FAQs →</a>
                </div> */}
                <div className="mt-10 bg-white dark:bg-zinc-800 p-6 text-center">
                    <p className="text-base text-gray-900 dark:text-white mb-4 font-medium">
                        Still have questions?
                    </p>
                    <button className="inline-flex items-center px-6 py-3 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition">
                        {/* Browse all FAQs → */}
                        <a href="/faq" className="inline-block hover:underline text-white">Browse all FAQs →</a>
                    </button>
                </div>
            </div>
        </div>
    )
}